import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedAnalyticsPie = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="chart" size="100%" color={stroke ?? color} />
);

export { LineRoundedAnalyticsPie };
